const config = {
  api_version: process.env.VUE_APP_API_VERSION,
  bucket_url: process.env.VUE_APP_BUCKET_URL,
  default_language: 'en',
  is_development: process.env.NODE_ENV === 'development',
};

export default config;
